export const themeBreakpoints = (media) => ({
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
        xs: media.xSmall,
        sm: media.small,
        md: media.medium,
        lg: media.large,
        xl: media.xLarge,
    },
});
